import { useTranslation } from 'react-i18next';
import type { IBuilderCardProps } from './IBuilderCardProps';
import { setTab, tabOn } from './patchViews';

/** «Вкладки форми» конструктора (прототип v4): «Загальне» — завжди ввімкнена; «Пов’язані елементи» й «Історія» — ADR-023 `tabs`. */
export function TabsCard({ rt, editor }: IBuilderCardProps) {
  const { t } = useTranslation();
  const row = (key: 'related' | 'history', label: string, sub: string) => {
    const on = tabOn(rt, editor.patch, key);
    return (
      <label className="rb-checkrow">
        <input type="checkbox" className="rb-check" checked={on} disabled={!editor.canEdit} onChange={() => editor.apply((p) => setTab(p, key, !on))} />
        <span className="rb-checkrow__label">{t(label)}</span><span className="rb-checkrow__desc">{t(sub)}</span>
      </label>
    );
  };
  return (
    <section className="rb-card" aria-label={t('rtBuilder.tabs')}>
      <div className="rb-card__title">{t('rtBuilder.tabs')}</div>
      <div className="rb-checks">
        <label className="rb-checkrow">
          <input type="checkbox" className="rb-check" checked disabled readOnly />
          <span className="rb-checkrow__label">{t('rtBuilder.tabGeneral')}</span><span className="rb-checkrow__desc">{t('rtBuilder.tabGeneralSub')}</span>
        </label>
        {row('related', 'rtBuilder.tabRelated', 'rtBuilder.tabRelatedSub')}
        {row('history', 'rtBuilder.tabHistory', 'rtBuilder.tabHistorySub')}
      </div>
    </section>
  );
}
